import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser, setToken, setUser } from "../redux/Slice/authSlice";
import { errorMessage } from "../services";
import { changePassword } from "../services/auth";
import { toast } from "../utils/toast";
import { Spinner } from "./Loader";
import PasswordInput from "./PasswordInput";

// Used on the forced "choose a new password" screen and on the Profile page
export default function ChangePasswordForm({ onDone }) {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setDone(false);
    if (form.newPassword.length < 8) return setError("The new password must be at least 8 characters.");
    if (form.newPassword !== form.confirm) return setError("The new passwords do not match.");

    setBusy(true);
    try {
      const { data } = await changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
      // Changing the password signs out older sessions, so the server hands back a fresh token
      dispatch(setToken(data.token));
      dispatch(setUser({ ...user, mustChangePassword: false }));
      setForm({ currentPassword: "", newPassword: "", confirm: "" });
      setDone(true);
      toast("Password changed. You are still signed in here.");
      if (onDone) onDone();
    } catch (err) {
      setError(errorMessage(err));
      toast(errorMessage(err), "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit}>
      {error && <div className="form-error">{error}</div>}
      {done && <div className="form-ok">Password changed.</div>}
      <label className="admin-field">Current password<PasswordInput autoComplete="current-password" required value={form.currentPassword} onChange={set("currentPassword")} /></label>
      <label className="admin-field">New password<PasswordInput autoComplete="new-password" required minLength={8} value={form.newPassword} onChange={set("newPassword")} /></label>
      <label className="admin-field">Confirm new password<PasswordInput autoComplete="new-password" required value={form.confirm} onChange={set("confirm")} /></label>
      <button className="primary-btn" disabled={busy}>{busy ? <><Spinner /> Saving</> : "Change password"}</button>
    </form>
  );
}
